"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalPaymentUpdatedContract = exports.ExternalPaymentCreatedContract = exports.ExternalPaymentEventDataContract = void 0;
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const events_1 = require("@getgreenline/events");
const payments_1 = require("@getgreenline/payments");
const homi_shared_1 = require("@getgreenline/homi-shared");
class ExternalApiPaymentLine {
}
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], ExternalApiPaymentLine.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ExternalApiPaymentLine.prototype, "productId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ExternalApiPaymentLine.prototype, "productName", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)({ name: 'price' }),
    __metadata("design:type", Number)
], ExternalApiPaymentLine.prototype, "subTotal", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)({ name: 'discountPrice' }),
    __metadata("design:type", Number)
], ExternalApiPaymentLine.prototype, "discount", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((val) => val.value || null),
    __metadata("design:type", Number)
], ExternalApiPaymentLine.prototype, "discountId", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)({ name: 'units' }),
    __metadata("design:type", Number)
], ExternalApiPaymentLine.prototype, "quantity", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((val) => Number(val.obj.price) + Number(val.obj.discountPrice)),
    __metadata("design:type", Number)
], ExternalApiPaymentLine.prototype, "total", void 0);
class ExternalApiTaxPaymentLine {
}
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], ExternalApiTaxPaymentLine.prototype, "paymentLineId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ExternalApiTaxPaymentLine.prototype, "taxName", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)({ name: 'amount' }),
    __metadata("design:type", Number)
], ExternalApiTaxPaymentLine.prototype, "total", void 0);
class ExternalApiTransaction {
}
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], ExternalApiTransaction.prototype, "paymentTypeId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)({ name: 'paymentType' }),
    __metadata("design:type", String)
], ExternalApiTransaction.prototype, "paymentTypeName", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)({ name: 'amount' }),
    __metadata("design:type", Number)
], ExternalApiTransaction.prototype, "total", void 0);
class ExternalApiCartDiscount {
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)({ name: 'productName' }),
    __metadata("design:type", String)
], ExternalApiCartDiscount.prototype, "discountName", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Transform)((val) => val.value || null),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], ExternalApiCartDiscount.prototype, "discountId", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)({ name: 'discountPrice' }),
    __metadata("design:type", Number)
], ExternalApiCartDiscount.prototype, "total", void 0);
class ExternalPaymentEventDataContract {
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ExternalPaymentEventDataContract.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((val) => val.value || null),
    __metadata("design:type", String)
], ExternalPaymentEventDataContract.prototype, "refundPaymentId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((val) => val.value || null),
    __metadata("design:type", String)
], ExternalPaymentEventDataContract.prototype, "deviceId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((val) => val.value || null),
    __metadata("design:type", String)
], ExternalPaymentEventDataContract.prototype, "deviceName", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ExternalPaymentEventDataContract.prototype, "customId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((val) => val.value || null),
    __metadata("design:type", String)
], ExternalPaymentEventDataContract.prototype, "notes", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((val) => val.value || null),
    __metadata("design:type", String)
], ExternalPaymentEventDataContract.prototype, "employeeId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((val) => val.value || null),
    __metadata("design:type", String)
], ExternalPaymentEventDataContract.prototype, "employeeName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((val) => val.value || null),
    __metadata("design:type", String)
], ExternalPaymentEventDataContract.prototype, "customerId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((val) => val.value || null),
    __metadata("design:type", String)
], ExternalPaymentEventDataContract.prototype, "customerName", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], ExternalPaymentEventDataContract.prototype, "completeDate", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", String)
], ExternalPaymentEventDataContract.prototype, "status", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], ExternalPaymentEventDataContract.prototype, "subTotal", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], ExternalPaymentEventDataContract.prototype, "total", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], ExternalPaymentEventDataContract.prototype, "tax", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)({ name: 'pennyAdjustment' }),
    __metadata("design:type", Number)
], ExternalPaymentEventDataContract.prototype, "pennyRounding", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsIn)(payments_1.Payments.paymentSourcesCheck),
    __metadata("design:type", Number)
], ExternalPaymentEventDataContract.prototype, "source", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)({ name: 'paymentLines' }),
    (0, class_transformer_1.Transform)((val) => val.value
        .filter((pl) => pl.type === homi_shared_1.PaymentLineType.PRODUCT)
        .map((line) => (0, class_transformer_1.plainToClass)(ExternalApiPaymentLine, line, { excludeExtraneousValues: true }))),
    __metadata("design:type", Array)
], ExternalPaymentEventDataContract.prototype, "lines", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)({ name: 'taxPaymentLines' }),
    (0, class_transformer_1.Transform)((val) => val.value.map((line) => (0, class_transformer_1.plainToClass)(ExternalApiTaxPaymentLine, line, { excludeExtraneousValues: true }))),
    __metadata("design:type", Array)
], ExternalPaymentEventDataContract.prototype, "taxes", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((val) => val.value.map((line) => (0, class_transformer_1.plainToClass)(ExternalApiTransaction, line, { excludeExtraneousValues: true }))),
    __metadata("design:type", Array)
], ExternalPaymentEventDataContract.prototype, "transactions", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((val) => val.obj.paymentLines
        .filter((pl) => pl.type === homi_shared_1.PaymentLineType.DISCOUNT)
        .map((line) => (0, class_transformer_1.plainToClass)(ExternalApiCartDiscount, line, { excludeExtraneousValues: true }))),
    __metadata("design:type", Array)
], ExternalPaymentEventDataContract.prototype, "cartDiscounts", void 0);
exports.ExternalPaymentEventDataContract = ExternalPaymentEventDataContract;
class ExternalPaymentCreatedContract extends events_1.ExternalEventContract {
    constructor(params) {
        super(params);
        this.payment = events_1.GreenlineEvent.create(ExternalPaymentEventDataContract, params.payment);
    }
}
exports.ExternalPaymentCreatedContract = ExternalPaymentCreatedContract;
class ExternalPaymentUpdatedContract extends events_1.ExternalEventContract {
    constructor(params) {
        super(params);
        this.payment = events_1.GreenlineEvent.create(ExternalPaymentEventDataContract, params.payment);
    }
}
exports.ExternalPaymentUpdatedContract = ExternalPaymentUpdatedContract;
//# sourceMappingURL=payments.js.map